module.exports = __webpack_public_path__ + "img/headphone.46bea98c.svg";